<template>
  <div class="prompt-detail-overlay" @click="$emit('close')">
    <div class="prompt-detail-container" @click.stop>
      <div class="prompt-detail-header">
        <div class="prompt-detail-title-section">
          <h2 class="prompt-detail-title">{{ prompt.title }}</h2>
          <div class="prompt-detail-meta">
            <div class="prompt-category">{{ prompt.label_name }}</div>
            <TagTypeComponent v-if="prompt.level" :tagType="prompt.level" />
          </div>
        </div>
        <button class="prompt-detail-close" @click="$emit('close')">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>
      
      <div class="prompt-detail-content">
        <div class="prompt-detail-section">
          <h3 class="prompt-detail-section-title">用户输入</h3>
          <p class="prompt-detail-text">{{ prompt.user_input }}</p>
        </div>
        
        <div class="prompt-detail-section">
          <h3 class="prompt-detail-section-title">提示词</h3>
          <pre class="prompt-detail-code">{{ prompt.description }}</pre>
        </div>
        
        <!-- <div class="prompt-detail-section">
          <h3 class="prompt-detail-section-title">标签</h3>
          <div class="prompt-detail-tags">
            <span v-for="tag in prompt.tags" :key="tag" class="prompt-detail-tag-item">
              {{ tag }}
            </span>
          </div>
        </div> -->
      </div>
      
      <div class="prompt-detail-footer">
        <div class="prompt-detail-meta">
          <span class="prompt-detail-meta-item"><font-awesome-icon :icon="['fas', 'eye']" /> {{ prompt.watch_count }}</span>
          <span class="prompt-detail-meta-item"><font-awesome-icon :icon="['fas', 'star']" /> {{ prompt.like_count }}</span>
          <span class="prompt-detail-meta-item"><font-awesome-icon :icon="['fas', 'copy']" /> {{ prompt.copy_count }}</span>
          <span class="prompt-detail-meta-item"><font-awesome-icon :icon="['fas', 'clock']" /> {{ prompt.create_at }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagTypeComponent from '../components/TagTypeComponent.vue'

export default {
  name: 'PromptDetail',
  components: {
    TagTypeComponent
  },
  props: {
    prompt: {
      type: Object,
      required: true
    }
  },
  emits: ['close']
}
</script>

<style scoped>
.prompt-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.prompt-detail-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.prompt-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
}

.prompt-detail-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.prompt-detail-meta {
  display: flex;
  align-items: center;
  gap: 20px;
}

.prompt-category {
  background-color: #e9ecef;
  color: #495057;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
}

.prompt-detail-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
  flex: 1;
}

.prompt-detail-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s;
}

.prompt-detail-close:hover {
  background-color: #eee;
  color: #333;
}

.prompt-detail-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.prompt-detail-section {
  margin-bottom: 24px;
}

.prompt-detail-section:last-child {
  margin-bottom: 0;
}

.prompt-detail-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #667eea;
}

.prompt-detail-text {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.prompt-detail-code {
  background-color: #f8f9fa;
  border: 1px solid #eee;
  border-radius: 6px;
  width: 100%;
  padding: 16px;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  color: #333;
}

.prompt-detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.prompt-detail-tag-item {
  background-color: #667eea;
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
}

.prompt-detail-footer {
  padding: 20px 24px;
  border-top: 1px solid #eee;
  background-color: #f8f9fa;
}

.prompt-detail-meta {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #666;
}

.prompt-detail-meta-item i {
  margin-right: 6px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .prompt-detail-container {
    max-width: 95vw;
  }
  
  .prompt-detail-header {
    padding: 16px;
  }
  
  .prompt-detail-title {
    font-size: 20px;
  }
  
  .prompt-detail-content {
    padding: 16px;
  }
  
  .prompt-detail-section-title {
    font-size: 16px;
  }
  
  .prompt-detail-footer {
    padding: 16px;
  }
  
  .prompt-detail-meta {
    flex-wrap: wrap;
    gap: 12px;
  }
}
</style>